// extracted by mini-css-extract-plugin
module.exports = {"yearSelector":"O4CBg","yearSelect":"tuXG7","spinner":"WFzmK","spinnerAnimation":"-AtBK","yearSelectorTitle":"sLp6X"};